import { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from "../../images/logo.png";
import Img1 from "../../images/globe.png";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { registerAction, clearErrors } from "../../../redux/actions/userActions";
import Loader from '../../loader/loader';
import "./signup.css";
import { REGISTER_USER_RESET } from '../../../redux/constants/userConstants';
import usePageMeta from '../../../hooks/usePageMeta';


const Signup = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, error, message } = useSelector((state) => state.register);
    const { isAuthenticated } = useSelector((state) => state.verifyEmailStore);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false)

    // 👇 For password hint display
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);

    usePageMeta("signup");

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!name) {
            toast.error("Please enter your name");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }

        if (!password) {
            toast.error("Please enter your password");
            return;
        }

        if (password.length < 8) {
            toast.error("Password should contain at least 8 characters");
            return;
        }


        const formData = new FormData();
        formData.append("name", name);
        formData.append("email", email);
        formData.append("password", password);

        dispatch(registerAction(formData));
    };

    useEffect(() => {
        if (message) {
            toast.success(message);
            localStorage.setItem("email", email);
            navigate('/verify-email');
            dispatch({ type: REGISTER_USER_RESET })
        }
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        if (isAuthenticated) {
            navigate('/');
        }
    }, [error, message, navigate, dispatch, email, isAuthenticated]);
      


    return (
        <Fragment>
            {loading ? (
                <Loader />
            ) : (
                <section className="min-h-[100vh] flex items-center justify-center p-[3vmax] signPage">
                    <div className="flex justify-between bg-white 
                        rounded-[1vmax] p-[2vmax] w-full lg:w-[80%] relative z-10 shadow-3 flex-col md:flex-row items-center">
                        <div className="w-[100%] lg:w-[52%]">
                            <div className='w-[12vmax] h-fit mx-auto md:mx-0'>
                                <img src={Logo} alt="logo" className='w-[100%]' />
                            </div>
                            <div className='w-[100%] flex-center animate-3d'>
                                <img src={Img1} alt="logo" className='hidden md:block w-[100%]' />
                            </div>
                        </div>

                        <div className="flex w-[100%]  md:w-[44%]">
                            <form className="flex flex-col justify-center items-center md:items-start w-[100%] lg:w-[85%]" onSubmit={handleSubmit}>
                                <h4 className='font-1 flex items-center text-[2vmax] lg:text-[1.6vmax] font-bold pt-[1vmax] md:pt-[0vmax]'>Welcome 
                                </h4>
                                <p className='pt-[0.2vmax] text-[1.5vmax] lg:text-[1.1vmax]' >Your Admin Dashboard</p>

                                {/* Name */}
                                <div className='flex flex-col mt-[4vmax] w-full'>
                                    <span className='text-[1.5vmax] lg:text-[1.1vmax]' >Name <span className='text-red-500'>*</span></span>
                                    <input
                                        type="text"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className='border-[0.15vmax] px-[2vmax] py-[0.7vmax] rounded-[0.6vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[1.1vmax]'
                                    />
                                </div>

                                {/* Email */}
                                <div className='flex flex-col mt-[1vmax] w-full'>
                                    <span className='text-[1.5vmax] lg:text-[1.1vmax]' >Email Address <span className='text-red-500'>*</span></span>
                                    <input
                                        type="text"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className='border-[0.15vmax] px-[2vmax] py-[0.7vmax] rounded-[0.6vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[1.1vmax]'
                                    />
                                </div>

                                {/* Password */}
                                <div className='flex flex-col mt-[1vmax] relative w-full'>
                                    <span className='text-[1.5vmax] lg:text-[1.1vmax]' >Password <span className='text-red-500'>*</span></span>
                                    <input
                                        type={showPassword ? 'text' : 'password'}

                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onFocus={() => setIsPasswordFocused(true)}
                                        onBlur={() => setIsPasswordFocused(false)}
                                        className='border-[0.15vmax] px-[2vmax] py-[0.7vmax] rounded-[0.6vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[1.1vmax]'
                                    />
                                    <button type='button'
                                        className='absolute top-[3.5vmax] lg:top-[2.9vmax] right-[1.5vmax] text-[1.6vmax] lg:text-[1.1vmax]'
                                        onClick={() => setShowPassword(prev => !prev)}>
                                        <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    </button>

                                    {/* Password Hint */}
                                    {isPasswordFocused && (
                                        <div
                                            className={`text-right text-[1vmax] pt-[0.2vmax] transition-all duration-300 ${password.length > 8 ? 'text-green-500' : 'text-red-500'
                                                }`}
                                        >
                                            Password <i className="fa-solid fa-angle-right"></i> 8
                                        </div>
                                    )}
                                </div>

                                <button
                                    type='submit'
                                    className='bg-[image:var(--gradient)] my-[2vmax] py-[0.7vmax] rounded-[2vmax] text-white font-bold shadow-2 block text-[1.8vmax] lg:text-[1.1vmax] px-[2vmax]'
                                >
                                    Sign Up
                                </button>

                                <h4 className='text-[1.6vmax] lg:text-1.1vmax' >
                                    Already have an account? <Link to={'/login'} className='text-[var(--color-2)]'>&nbsp;Sign in</Link>
                                </h4>
                            </form>
                        </div>
                    </div>
                </section>
            )}
        </Fragment>
    );
};

export default Signup;
